import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { WoodboxPriceGroup } from "@/types/forms/woodbox.form";
import { Pen } from "lucide-react";

type OptionsWoodboxItemProps = {
  group: WoodboxPriceGroup;
  index: number;
  setEditWoodBox: (item: WoodboxPriceGroup["items"]) => void;
};

export const OptionsWoodboxItem = ({ group, index, setEditWoodBox }: OptionsWoodboxItemProps) => {
  const { t } = useTranslation("boParameters");
  return (
    <div
      key={`${index}-${group.bottleVolume}`}
      className="flex-col items-center justify-between gap-4 rounded-lg border border-gray-200 bg-gray-50 p-4"
    >
      <div className="flex flex-row items-center justify-between">
        <p className="text-xs font-medium text-gray-500">
          {t("woodboxItem.groupLabel", { bottleVolume: group.bottleVolume, region: group.region })}
        </p>
        <Button variant="ghost" onClick={() => setEditWoodBox(group.items)}>
          <Pen size={20} className="text-gray-500" />
        </Button>
      </div>
      <div className="flex flex-col gap-2 divide-y pt-4">
        {group?.items?.map((item) => (
          <div className="grid grid-cols-2 gap-2 pt-2" key={item.id}>
            <p className="text-sm font-medium text-gray-900">
              {t("woodboxItem.bottleCount", { count: item.bottleQuantity })}
            </p>
            <p className="text-sm font-medium text-gray-900">{item.price} €</p>
          </div>
        ))}
      </div>
    </div>
  );
};
